import Environment from './Environment';
import { report } from '../report';
import { LanguageKey, defaultLanguageKey, fallbackLanguageKey } from './SDK/Language';
import { GameJSON } from '../GameJSON';

// TODO: refine the to actual possible keys
type TextKey = string;

export type LanguageData = {
    [textKey in TextKey]: {
        [locale in LanguageKey]: string;
    };
};

//

export default class LocaleManager {
    private languageData: LanguageData | null = null;
    private languageKey = defaultLanguageKey;

    constructor() {
        let lang: LanguageData = {};

        try {
            lang = JSON.parse(GameJSON.lang);
        } catch (e) {
            console.warn(e);
        }

        this.setLanguageData(lang);
    }

    public setLanguageData(languageData: LanguageData) {
        // TODO: validate
        this.languageData = languageData;
    }

    public getLanguage(): string {
        return this.languageKey;
    }

    public setLanguage(languageKey: LanguageKey): void {
        console.log("setting to :: " + languageKey)
        if (!Object.values(LanguageKey).includes(languageKey)) {
            report('Ignoring unsupported locale', {
                once: true,
                sampleRate: 0.1,
                tags: {
                    currentLanguageKey: this.languageKey,
                    attemptedLanguageKey: languageKey,
                },
            });
            return;
        }
        this.languageKey = languageKey;
    }

    public getText(textKey: TextKey): string {
        if (!this.languageData) {
            report('Language data not available', { once: true });
            return textKey;
        }

        if (!this.languageData[textKey]) {
            report('Data for given localization key not found', {
                once: true,
                sampleRate: 0.1,
                tags: { textKey },
            });
            return textKey;
        }

        let languageKey: LanguageKey = this.languageKey;

        if (process?.env.NODE_ENV === Environment.DEVELOPMENT) {
            languageKey = (localStorage.getItem('debugForceLocale') as LanguageKey) ?? languageKey;
        }

        return String(
            this.languageData[textKey][languageKey] || this.languageData[textKey][fallbackLanguageKey] || textKey
        );
    }

    
}
